export default [
  {
    id: "1",
    textDropDownEn: "-- Choose --",
    nationality: "--Choose--",
  },
  {
    id: "4",
    alpha_2_code: "AF",
    alpha_3_code: "AFG",
    textDropDownEn: "Afghanistan",
    nationality: "Afghan",
  },
  {
    id: "248",
    alpha_2_code: "AX",
    alpha_3_code: "ALA",
    textDropDownEn: "\u00c5land Islands",
    nationality: "\u00c5land Island",
  },
  {
    id: "8",
    alpha_2_code: "AL",
    alpha_3_code: "ALB",
    textDropDownEn: "Albania",
    nationality: "Albanian",
  },
  {
    id: "12",
    alpha_2_code: "DZ",
    alpha_3_code: "DZA",
    textDropDownEn: "Algeria",
    nationality: "Algerian",
  },
  {
    id: "16",
    alpha_2_code: "AS",
    alpha_3_code: "ASM",
    textDropDownEn: "American Samoa",
    nationality: "American Samoan",
  },
  {
    id: "20",
    alpha_2_code: "AD",
    alpha_3_code: "AND",
    textDropDownEn: "Andorra",
    nationality: "Andorran",
  },
  {
    id: "24",
    alpha_2_code: "AO",
    alpha_3_code: "AGO",
    textDropDownEn: "Angola",
    nationality: "Angolan",
  },
  {
    id: "660",
    alpha_2_code: "AI",
    alpha_3_code: "AIA",
    textDropDownEn: "Anguilla",
    nationality: "Anguillan",
  },
  {
    id: "10",
    alpha_2_code: "AQ",
    alpha_3_code: "ATA",
    textDropDownEn: "Antarctica",
    nationality: "Antarctic",
  },
  {
    id: "28",
    alpha_2_code: "AG",
    alpha_3_code: "ATG",
    textDropDownEn: "Antigua and Barbuda",
    nationality: "Antiguan or Barbudan",
  },
  {
    id: "32",
    alpha_2_code: "AR",
    alpha_3_code: "ARG",
    textDropDownEn: "Argentina",
    nationality: "Argentine",
  },
  {
    id: "51",
    alpha_2_code: "AM",
    alpha_3_code: "ARM",
    textDropDownEn: "Armenia",
    nationality: "Armenian",
  },
  {
    id: "533",
    alpha_2_code: "AW",
    alpha_3_code: "ABW",
    textDropDownEn: "Aruba",
    nationality: "Aruban",
  },
  {
    id: "36",
    alpha_2_code: "AU",
    alpha_3_code: "AUS",
    textDropDownEn: "Australia",
    nationality: "Australian",
  },
  {
    id: "40",
    alpha_2_code: "AT",
    alpha_3_code: "AUT",
    textDropDownEn: "Austria",
    nationality: "Austrian",
  },
  {
    id: "31",
    alpha_2_code: "AZ",
    alpha_3_code: "AZE",
    textDropDownEn: "Azerbaijan",
    nationality: "Azerbaijani, Azeri",
  },
  {
    id: "44",
    alpha_2_code: "BS",
    alpha_3_code: "BHS",
    textDropDownEn: "Bahamas",
    nationality: "Bahamian",
  },
  {
    id: "48",
    alpha_2_code: "BH",
    alpha_3_code: "BHR",
    textDropDownEn: "Bahrain",
    nationality: "Bahraini",
  },
  {
    id: "50",
    alpha_2_code: "BD",
    alpha_3_code: "BGD",
    textDropDownEn: "Bangladesh",
    nationality: "Bangladeshi",
  },
  {
    id: "52",
    alpha_2_code: "BB",
    alpha_3_code: "BRB",
    textDropDownEn: "Barbados",
    nationality: "Barbadian",
  },
  {
    id: "112",
    alpha_2_code: "BY",
    alpha_3_code: "BLR",
    textDropDownEn: "Belarus",
    nationality: "Belarusian",
  },
  {
    id: "56",
    alpha_2_code: "BE",
    alpha_3_code: "BEL",
    textDropDownEn: "Belgium",
    nationality: "Belgian",
  },
  {
    id: "84",
    alpha_2_code: "BZ",
    alpha_3_code: "BLZ",
    textDropDownEn: "Belize",
    nationality: "Belizean",
  },
  {
    id: "204",
    alpha_2_code: "BJ",
    alpha_3_code: "BEN",
    textDropDownEn: "Benin",
    nationality: "Beninese, Beninois",
  },
  {
    id: "60",
    alpha_2_code: "BM",
    alpha_3_code: "BMU",
    textDropDownEn: "Bermuda",
    nationality: "Bermudian, Bermudan",
  },
  {
    id: "64",
    alpha_2_code: "BT",
    alpha_3_code: "BTN",
    textDropDownEn: "Bhutan",
    nationality: "Bhutanese",
  },
  {
    id: "68",
    alpha_2_code: "BO",
    alpha_3_code: "BOL",
    textDropDownEn: "Bolivia (Plurinational State of)",
    nationality: "Bolivian",
  },
  {
    id: "535",
    alpha_2_code: "BQ",
    alpha_3_code: "BES",
    textDropDownEn: "Bonaire, Sint Eustatius and Saba",
    nationality: "Bonaire",
  },
  {
    id: "70",
    alpha_2_code: "BA",
    alpha_3_code: "BIH",
    textDropDownEn: "Bosnia and Herzegovina",
    nationality: "Bosnian or Herzegovinian",
  },
  {
    id: "72",
    alpha_2_code: "BW",
    alpha_3_code: "BWA",
    textDropDownEn: "Botswana",
    nationality: "Motswana, Botswanan",
  },
  {
    id: "74",
    alpha_2_code: "BV",
    alpha_3_code: "BVT",
    textDropDownEn: "Bouvet Island",
    nationality: "Bouvet Island",
  },
  {
    id: "76",
    alpha_2_code: "BR",
    alpha_3_code: "BRA",
    textDropDownEn: "Brazil",
    nationality: "Brazilian",
  },
  {
    id: "86",
    alpha_2_code: "IO",
    alpha_3_code: "IOT",
    textDropDownEn: "British Indian Ocean Territory",
    nationality: "BIOT",
  },
  {
    id: "96",
    alpha_2_code: "BN",
    alpha_3_code: "BRN",
    textDropDownEn: "Brunei Darussalam",
    nationality: "Bruneian",
  },
  {
    id: "100",
    alpha_2_code: "BG",
    alpha_3_code: "BGR",
    textDropDownEn: "Bulgaria",
    nationality: "Bulgarian",
  },
  {
    id: "854",
    alpha_2_code: "BF",
    alpha_3_code: "BFA",
    textDropDownEn: "Burkina Faso",
    nationality: "Burkinab\u00e9",
  },
  {
    id: "108",
    alpha_2_code: "BI",
    alpha_3_code: "BDI",
    textDropDownEn: "Burundi",
    nationality: "Burundian",
  },
  {
    id: "132",
    alpha_2_code: "CV",
    alpha_3_code: "CPV",
    textDropDownEn: "Cabo Verde",
    nationality: "Cabo Verdean",
  },
  {
    id: "116",
    alpha_2_code: "KH",
    alpha_3_code: "KHM",
    textDropDownEn: "Cambodia",
    nationality: "Cambodian",
  },
  {
    id: "120",
    alpha_2_code: "CM",
    alpha_3_code: "CMR",
    textDropDownEn: "Cameroon",
    nationality: "Cameroonian",
  },
  {
    id: "124",
    alpha_2_code: "CA",
    alpha_3_code: "CAN",
    textDropDownEn: "Canada",
    nationality: "Canadian",
  },
  {
    id: "136",
    alpha_2_code: "KY",
    alpha_3_code: "CYM",
    textDropDownEn: "Cayman Islands",
    nationality: "Caymanian",
  },
  {
    id: "140",
    alpha_2_code: "CF",
    alpha_3_code: "CAF",
    textDropDownEn: "Central African Republic",
    nationality: "Central African",
  },
  {
    id: "148",
    alpha_2_code: "TD",
    alpha_3_code: "TCD",
    textDropDownEn: "Chad",
    nationality: "Chadian",
  },
  {
    id: "152",
    alpha_2_code: "CL",
    alpha_3_code: "CHL",
    textDropDownEn: "Chile",
    nationality: "Chilean",
  },
  {
    id: "156",
    alpha_2_code: "CN",
    alpha_3_code: "CHN",
    textDropDownEn: "China",
    nationality: "Chinese",
  },
  {
    id: "162",
    alpha_2_code: "CX",
    alpha_3_code: "CXR",
    textDropDownEn: "Christmas Island",
    nationality: "Christmas Island",
  },
  {
    id: "166",
    alpha_2_code: "CC",
    alpha_3_code: "CCK",
    textDropDownEn: "Cocos (Keeling) Islands",
    nationality: "Cocos Island",
  },
  {
    id: "170",
    alpha_2_code: "CO",
    alpha_3_code: "COL",
    textDropDownEn: "Colombia",
    nationality: "Colombian",
  },
  {
    id: "174",
    alpha_2_code: "KM",
    alpha_3_code: "COM",
    textDropDownEn: "Comoros",
    nationality: "Comoran, Comorian",
  },
  {
    id: "178",
    alpha_2_code: "CG",
    alpha_3_code: "COG",
    textDropDownEn: "Congo (Republic of the)",
    nationality: "Congolese",
  },
  {
    id: "180",
    alpha_2_code: "CD",
    alpha_3_code: "COD",
    textDropDownEn: "Congo (Democratic Republic of the)",
    nationality: "Congolese",
  },
  {
    id: "184",
    alpha_2_code: "CK",
    alpha_3_code: "COK",
    textDropDownEn: "Cook Islands",
    nationality: "Cook Island",
  },
  {
    id: "188",
    alpha_2_code: "CR",
    alpha_3_code: "CRI",
    textDropDownEn: "Costa Rica",
    nationality: "Costa Rican",
  },
  {
    id: "384",
    alpha_2_code: "CI",
    alpha_3_code: "CIV",
    textDropDownEn: "C\u00f4te d'Ivoire",
    nationality: "Ivorian",
  },
  {
    id: "191",
    alpha_2_code: "HR",
    alpha_3_code: "HRV",
    textDropDownEn: "Croatia",
    nationality: "Croatian",
  },
  {
    id: "192",
    alpha_2_code: "CU",
    alpha_3_code: "CUB",
    textDropDownEn: "Cuba",
    nationality: "Cuban",
  },
  {
    id: "531",
    alpha_2_code: "CW",
    alpha_3_code: "CUW",
    textDropDownEn: "Cura\u00e7ao",
    nationality: "Cura\u00e7aoan",
  },
  {
    id: "196",
    alpha_2_code: "CY",
    alpha_3_code: "CYP",
    textDropDownEn: "Cyprus",
    nationality: "Cypriot",
  },
  {
    id: "203",
    alpha_2_code: "CZ",
    alpha_3_code: "CZE",
    textDropDownEn: "Czech Republic",
    nationality: "Czech",
  },
  {
    id: "208",
    alpha_2_code: "DK",
    alpha_3_code: "DNK",
    textDropDownEn: "Denmark",
    nationality: "Danish",
  },
  {
    id: "262",
    alpha_2_code: "DJ",
    alpha_3_code: "DJI",
    textDropDownEn: "Djibouti",
    nationality: "Djiboutian",
  },
  {
    id: "212",
    alpha_2_code: "DM",
    alpha_3_code: "DMA",
    textDropDownEn: "Dominica",
    nationality: "Dominican",
  },
  {
    id: "214",
    alpha_2_code: "DO",
    alpha_3_code: "DOM",
    textDropDownEn: "Dominican Republic",
    nationality: "Dominican",
  },
  {
    id: "218",
    alpha_2_code: "EC",
    alpha_3_code: "ECU",
    textDropDownEn: "Ecuador",
    nationality: "Ecuadorian",
  },
  {
    id: "818",
    alpha_2_code: "EG",
    alpha_3_code: "EGY",
    textDropDownEn: "Egypt",
    nationality: "Egyptian",
  },
  {
    id: "222",
    alpha_2_code: "SV",
    alpha_3_code: "SLV",
    textDropDownEn: "El Salvador",
    nationality: "Salvadoran",
  },
  {
    id: "226",
    alpha_2_code: "GQ",
    alpha_3_code: "GNQ",
    textDropDownEn: "Equatorial Guinea",
    nationality: "Equatorial Guinean, Equatoguinean",
  },
  {
    id: "232",
    alpha_2_code: "ER",
    alpha_3_code: "ERI",
    textDropDownEn: "Eritrea",
    nationality: "Eritrean",
  },
  {
    id: "233",
    alpha_2_code: "EE",
    alpha_3_code: "EST",
    textDropDownEn: "Estonia",
    nationality: "Estonian",
  },
  {
    id: "231",
    alpha_2_code: "ET",
    alpha_3_code: "ETH",
    textDropDownEn: "Ethiopia",
    nationality: "Ethiopian",
  },
  {
    id: "238",
    alpha_2_code: "FK",
    alpha_3_code: "FLK",
    textDropDownEn: "Falkland Islands (Malvinas)",
    nationality: "Falkland Island",
  },
  {
    id: "234",
    alpha_2_code: "FO",
    alpha_3_code: "FRO",
    textDropDownEn: "Faroe Islands",
    nationality: "Faroese",
  },
  {
    id: "242",
    alpha_2_code: "FJ",
    alpha_3_code: "FJI",
    textDropDownEn: "Fiji",
    nationality: "Fijian",
  },
  {
    id: "246",
    alpha_2_code: "FI",
    alpha_3_code: "FIN",
    textDropDownEn: "Finland",
    nationality: "Finnish",
  },
  {
    id: "250",
    alpha_2_code: "FR",
    alpha_3_code: "FRA",
    textDropDownEn: "France",
    nationality: "French",
  },
  {
    id: "254",
    alpha_2_code: "GF",
    alpha_3_code: "GUF",
    textDropDownEn: "French Guiana",
    nationality: "French Guianese",
  },
  {
    id: "258",
    alpha_2_code: "PF",
    alpha_3_code: "PYF",
    textDropDownEn: "French Polynesia",
    nationality: "French Polynesian",
  },
  {
    id: "260",
    alpha_2_code: "TF",
    alpha_3_code: "ATF",
    textDropDownEn: "French Southern Territories",
    nationality: "French Southern Territories",
  },
  {
    id: "266",
    alpha_2_code: "GA",
    alpha_3_code: "GAB",
    textDropDownEn: "Gabon",
    nationality: "Gabonese",
  },
  {
    id: "270",
    alpha_2_code: "GM",
    alpha_3_code: "GMB",
    textDropDownEn: "Gambia",
    nationality: "Gambian",
  },
  {
    id: "268",
    alpha_2_code: "GE",
    alpha_3_code: "GEO",
    textDropDownEn: "Georgia",
    nationality: "Georgian",
  },
  {
    id: "276",
    alpha_2_code: "DE",
    alpha_3_code: "DEU",
    textDropDownEn: "Germany",
    nationality: "German",
  },
  {
    id: "288",
    alpha_2_code: "GH",
    alpha_3_code: "GHA",
    textDropDownEn: "Ghana",
    nationality: "Ghanaian",
  },
  {
    id: "292",
    alpha_2_code: "GI",
    alpha_3_code: "GIB",
    textDropDownEn: "Gibraltar",
    nationality: "Gibraltar",
  },
  {
    id: "300",
    alpha_2_code: "GR",
    alpha_3_code: "GRC",
    textDropDownEn: "Greece",
    nationality: "Greek, Hellenic",
  },
  {
    id: "304",
    alpha_2_code: "GL",
    alpha_3_code: "GRL",
    textDropDownEn: "Greenland",
    nationality: "Greenlandic",
  },
  {
    id: "308",
    alpha_2_code: "GD",
    alpha_3_code: "GRD",
    textDropDownEn: "Grenada",
    nationality: "Grenadian",
  },
  {
    id: "312",
    alpha_2_code: "GP",
    alpha_3_code: "GLP",
    textDropDownEn: "Guadeloupe",
    nationality: "Guadeloupe",
  },
  {
    id: "316",
    alpha_2_code: "GU",
    alpha_3_code: "GUM",
    textDropDownEn: "Guam",
    nationality: "Guamanian, Guambat",
  },
  {
    id: "320",
    alpha_2_code: "GT",
    alpha_3_code: "GTM",
    textDropDownEn: "Guatemala",
    nationality: "Guatemalan",
  },
  {
    id: "831",
    alpha_2_code: "GG",
    alpha_3_code: "GGY",
    textDropDownEn: "Guernsey",
    nationality: "Channel Island",
  },
  {
    id: "324",
    alpha_2_code: "GN",
    alpha_3_code: "GIN",
    textDropDownEn: "Guinea",
    nationality: "Guinean",
  },
  {
    id: "624",
    alpha_2_code: "GW",
    alpha_3_code: "GNB",
    textDropDownEn: "Guinea-Bissau",
    nationality: "Bissau-Guinean",
  },
  {
    id: "328",
    alpha_2_code: "GY",
    alpha_3_code: "GUY",
    textDropDownEn: "Guyana",
    nationality: "Guyanese",
  },
  {
    id: "332",
    alpha_2_code: "HT",
    alpha_3_code: "HTI",
    textDropDownEn: "Haiti",
    nationality: "Haitian",
  },
  {
    id: "334",
    alpha_2_code: "HM",
    alpha_3_code: "HMD",
    textDropDownEn: "Heard Island and McDonald Islands",
    nationality: "Heard Island or McDonald Islands",
  },
  {
    id: "336",
    alpha_2_code: "VA",
    alpha_3_code: "VAT",
    textDropDownEn: "Vatican City State",
    nationality: "Vatican",
  },
  {
    id: "340",
    alpha_2_code: "HN",
    alpha_3_code: "HND",
    textDropDownEn: "Honduras",
    nationality: "Honduran",
  },
  {
    id: "344",
    alpha_2_code: "HK",
    alpha_3_code: "HKG",
    textDropDownEn: "Hong Kong",
    nationality: "Hong Kong, Hong Kongese",
  },
  {
    id: "348",
    alpha_2_code: "HU",
    alpha_3_code: "HUN",
    textDropDownEn: "Hungary",
    nationality: "Hungarian, Magyar",
  },
  {
    id: "352",
    alpha_2_code: "IS",
    alpha_3_code: "ISL",
    textDropDownEn: "Iceland",
    nationality: "Icelandic",
  },
  {
    id: "356",
    alpha_2_code: "IN",
    alpha_3_code: "IND",
    textDropDownEn: "India",
    nationality: "Indian",
  },
  {
    id: "360",
    alpha_2_code: "ID",
    alpha_3_code: "IDN",
    textDropDownEn: "Indonesia",
    nationality: "Indonesian",
  },
  {
    id: "364",
    alpha_2_code: "IR",
    alpha_3_code: "IRN",
    textDropDownEn: "Iran",
    nationality: "Iranian, Persian",
  },
  {
    id: "368",
    alpha_2_code: "IQ",
    alpha_3_code: "IRQ",
    textDropDownEn: "Iraq",
    nationality: "Iraqi",
  },
  {
    id: "372",
    alpha_2_code: "IE",
    alpha_3_code: "IRL",
    textDropDownEn: "Ireland",
    nationality: "Irish",
  },
  {
    id: "833",
    alpha_2_code: "IM",
    alpha_3_code: "IMN",
    textDropDownEn: "Isle of Man",
    nationality: "Manx",
  },
  {
    id: "376",
    alpha_2_code: "IL",
    alpha_3_code: "ISR",
    textDropDownEn: "Israel",
    nationality: "Israeli",
  },
  {
    id: "380",
    alpha_2_code: "IT",
    alpha_3_code: "ITA",
    textDropDownEn: "Italy",
    nationality: "Italian",
  },
  {
    id: "388",
    alpha_2_code: "JM",
    alpha_3_code: "JAM",
    textDropDownEn: "Jamaica",
    nationality: "Jamaican",
  },
  {
    id: "392",
    alpha_2_code: "JP",
    alpha_3_code: "JPN",
    textDropDownEn: "Japan",
    nationality: "Japanese",
  },
  {
    id: "832",
    alpha_2_code: "JE",
    alpha_3_code: "JEY",
    textDropDownEn: "Jersey",
    nationality: "Channel Island",
  },
  {
    id: "400",
    alpha_2_code: "JO",
    alpha_3_code: "JOR",
    textDropDownEn: "Jordan",
    nationality: "Jordanian",
  },
  {
    id: "398",
    alpha_2_code: "KZ",
    alpha_3_code: "KAZ",
    textDropDownEn: "Kazakhstan",
    nationality: "Kazakhstani, Kazakh",
  },
  {
    id: "404",
    alpha_2_code: "KE",
    alpha_3_code: "KEN",
    textDropDownEn: "Kenya",
    nationality: "Kenyan",
  },
  {
    id: "296",
    alpha_2_code: "KI",
    alpha_3_code: "KIR",
    textDropDownEn: "Kiribati",
    nationality: "I-Kiribati",
  },
  {
    id: "408",
    alpha_2_code: "KP",
    alpha_3_code: "PRK",
    textDropDownEn: "Korea (Democratic People's Republic of)",
    nationality: "North Korean",
  },
  {
    id: "410",
    alpha_2_code: "KR",
    alpha_3_code: "KOR",
    textDropDownEn: "Korea (Republic of)",
    nationality: "South Korean",
  },
  {
    id: "414",
    alpha_2_code: "KW",
    alpha_3_code: "KWT",
    textDropDownEn: "Kuwait",
    nationality: "Kuwaiti",
  },
  {
    id: "417",
    alpha_2_code: "KG",
    alpha_3_code: "KGZ",
    textDropDownEn: "Kyrgyzstan",
    nationality: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz",
  },
  {
    id: "418",
    alpha_2_code: "LA",
    alpha_3_code: "LAO",
    textDropDownEn: "Lao People's Democratic Republic",
    nationality: "Lao, Laotian",
  },
  {
    id: "428",
    alpha_2_code: "LV",
    alpha_3_code: "LVA",
    textDropDownEn: "Latvia",
    nationality: "Latvian",
  },
  {
    id: "422",
    alpha_2_code: "LB",
    alpha_3_code: "LBN",
    textDropDownEn: "Lebanon",
    nationality: "Lebanese",
  },
  {
    id: "426",
    alpha_2_code: "LS",
    alpha_3_code: "LSO",
    textDropDownEn: "Lesotho",
    nationality: "Basotho",
  },
  {
    id: "430",
    alpha_2_code: "LR",
    alpha_3_code: "LBR",
    textDropDownEn: "Liberia",
    nationality: "Liberian",
  },
  {
    id: "434",
    alpha_2_code: "LY",
    alpha_3_code: "LBY",
    textDropDownEn: "Libya",
    nationality: "Libyan",
  },
  {
    id: "438",
    alpha_2_code: "LI",
    alpha_3_code: "LIE",
    textDropDownEn: "Liechtenstein",
    nationality: "Liechtenstein",
  },
  {
    id: "440",
    alpha_2_code: "LT",
    alpha_3_code: "LTU",
    textDropDownEn: "Lithuania",
    nationality: "Lithuanian",
  },
  {
    id: "442",
    alpha_2_code: "LU",
    alpha_3_code: "LUX",
    textDropDownEn: "Luxembourg",
    nationality: "Luxembourg, Luxembourgish",
  },
  {
    id: "446",
    alpha_2_code: "MO",
    alpha_3_code: "MAC",
    textDropDownEn: "Macao",
    nationality: "Macanese, Chinese",
  },
  {
    id: "807",
    alpha_2_code: "MK",
    alpha_3_code: "MKD",
    textDropDownEn: "Macedonia (the former Yugoslav Republic of)",
    nationality: "Macedonian",
  },
  {
    id: "450",
    alpha_2_code: "MG",
    alpha_3_code: "MDG",
    textDropDownEn: "Madagascar",
    nationality: "Malagasy",
  },
  {
    id: "454",
    alpha_2_code: "MW",
    alpha_3_code: "MWI",
    textDropDownEn: "Malawi",
    nationality: "Malawian",
  },
  {
    id: "458",
    alpha_2_code: "MY",
    alpha_3_code: "MYS",
    textDropDownEn: "Malaysia",
    nationality: "Malaysian",
  },
  {
    id: "462",
    alpha_2_code: "MV",
    alpha_3_code: "MDV",
    textDropDownEn: "Maldives",
    nationality: "Maldivian",
  },
  {
    id: "466",
    alpha_2_code: "ML",
    alpha_3_code: "MLI",
    textDropDownEn: "Mali",
    nationality: "Malian, Malinese",
  },
  {
    id: "470",
    alpha_2_code: "MT",
    alpha_3_code: "MLT",
    textDropDownEn: "Malta",
    nationality: "Maltese",
  },
  {
    id: "584",
    alpha_2_code: "MH",
    alpha_3_code: "MHL",
    textDropDownEn: "Marshall Islands",
    nationality: "Marshallese",
  },
  {
    id: "474",
    alpha_2_code: "MQ",
    alpha_3_code: "MTQ",
    textDropDownEn: "Martinique",
    nationality: "Martiniquais, Martinican",
  },
  {
    id: "478",
    alpha_2_code: "MR",
    alpha_3_code: "MRT",
    textDropDownEn: "Mauritania",
    nationality: "Mauritanian",
  },
  {
    id: "480",
    alpha_2_code: "MU",
    alpha_3_code: "MUS",
    textDropDownEn: "Mauritius",
    nationality: "Mauritian",
  },
  {
    id: "175",
    alpha_2_code: "YT",
    alpha_3_code: "MYT",
    textDropDownEn: "Mayotte",
    nationality: "Mahoran",
  },
  {
    id: "484",
    alpha_2_code: "MX",
    alpha_3_code: "MEX",
    textDropDownEn: "Mexico",
    nationality: "Mexican",
  },
  {
    id: "583",
    alpha_2_code: "FM",
    alpha_3_code: "FSM",
    textDropDownEn: "Micronesia (Federated States of)",
    nationality: "Micronesian",
  },
  {
    id: "498",
    alpha_2_code: "MD",
    alpha_3_code: "MDA",
    textDropDownEn: "Moldova (Republic of)",
    nationality: "Moldovan",
  },
  {
    id: "492",
    alpha_2_code: "MC",
    alpha_3_code: "MCO",
    textDropDownEn: "Monaco",
    nationality: "Mon\u00e9gasque, Monacan",
  },
  {
    id: "496",
    alpha_2_code: "MN",
    alpha_3_code: "MNG",
    textDropDownEn: "Mongolia",
    nationality: "Mongolian",
  },
  {
    id: "499",
    alpha_2_code: "ME",
    alpha_3_code: "MNE",
    textDropDownEn: "Montenegro",
    nationality: "Montenegrin",
  },
  {
    id: "500",
    alpha_2_code: "MS",
    alpha_3_code: "MSR",
    textDropDownEn: "Montserrat",
    nationality: "Montserratian",
  },
  {
    id: "504",
    alpha_2_code: "MA",
    alpha_3_code: "MAR",
    textDropDownEn: "Morocco",
    nationality: "Moroccan",
  },
  {
    id: "508",
    alpha_2_code: "MZ",
    alpha_3_code: "MOZ",
    textDropDownEn: "Mozambique",
    nationality: "Mozambican",
  },
  {
    id: "104",
    alpha_2_code: "MM",
    alpha_3_code: "MMR",
    textDropDownEn: "Myanmar",
    nationality: "Burmese",
  },
  {
    id: "516",
    alpha_2_code: "NA",
    alpha_3_code: "NAM",
    textDropDownEn: "Namibia",
    nationality: "Namibian",
  },
  {
    id: "520",
    alpha_2_code: "NR",
    alpha_3_code: "NRU",
    textDropDownEn: "Nauru",
    nationality: "Nauruan",
  },
  {
    id: "524",
    alpha_2_code: "NP",
    alpha_3_code: "NPL",
    textDropDownEn: "Nepal",
    nationality: "Nepali, Nepalese",
  },
  {
    id: "528",
    alpha_2_code: "NL",
    alpha_3_code: "NLD",
    textDropDownEn: "Netherlands",
    nationality: "Dutch, Netherlandic",
  },
  {
    id: "540",
    alpha_2_code: "NC",
    alpha_3_code: "NCL",
    textDropDownEn: "New Caledonia",
    nationality: "New Caledonian",
  },
  {
    id: "554",
    alpha_2_code: "NZ",
    alpha_3_code: "NZL",
    textDropDownEn: "New Zealand",
    nationality: "New Zealand, NZ",
  },
  {
    id: "558",
    alpha_2_code: "NI",
    alpha_3_code: "NIC",
    textDropDownEn: "Nicaragua",
    nationality: "Nicaraguan",
  },
  {
    id: "562",
    alpha_2_code: "NE",
    alpha_3_code: "NER",
    textDropDownEn: "Niger",
    nationality: "Nigerien",
  },
  {
    id: "566",
    alpha_2_code: "NG",
    alpha_3_code: "NGA",
    textDropDownEn: "Nigeria",
    nationality: "Nigerian",
  },
  {
    id: "570",
    alpha_2_code: "NU",
    alpha_3_code: "NIU",
    textDropDownEn: "Niue",
    nationality: "Niuean",
  },
  {
    id: "574",
    alpha_2_code: "NF",
    alpha_3_code: "NFK",
    textDropDownEn: "Norfolk Island",
    nationality: "Norfolk Island",
  },
  {
    id: "580",
    alpha_2_code: "MP",
    alpha_3_code: "MNP",
    textDropDownEn: "Northern Mariana Islands",
    nationality: "Northern Marianan",
  },
  {
    id: "578",
    alpha_2_code: "NO",
    alpha_3_code: "NOR",
    textDropDownEn: "Norway",
    nationality: "Norwegian",
  },
  {
    id: "512",
    alpha_2_code: "OM",
    alpha_3_code: "OMN",
    textDropDownEn: "Oman",
    nationality: "Omani",
  },
  {
    id: "586",
    alpha_2_code: "PK",
    alpha_3_code: "PAK",
    textDropDownEn: "Pakistan",
    nationality: "Pakistani",
  },
  {
    id: "585",
    alpha_2_code: "PW",
    alpha_3_code: "PLW",
    textDropDownEn: "Palau",
    nationality: "Palauan",
  },
  {
    id: "275",
    alpha_2_code: "PS",
    alpha_3_code: "PSE",
    textDropDownEn: "Palestine, State of",
    nationality: "Palestinian",
  },
  {
    id: "591",
    alpha_2_code: "PA",
    alpha_3_code: "PAN",
    textDropDownEn: "Panama",
    nationality: "Panamanian",
  },
  {
    id: "598",
    alpha_2_code: "PG",
    alpha_3_code: "PNG",
    textDropDownEn: "Papua New Guinea",
    nationality: "Papua New Guinean, Papuan",
  },
  {
    id: "600",
    alpha_2_code: "PY",
    alpha_3_code: "PRY",
    textDropDownEn: "Paraguay",
    nationality: "Paraguayan",
  },
  {
    id: "604",
    alpha_2_code: "PE",
    alpha_3_code: "PER",
    textDropDownEn: "Peru",
    nationality: "Peruvian",
  },
  {
    id: "608",
    alpha_2_code: "PH",
    alpha_3_code: "PHL",
    textDropDownEn: "Philippines",
    nationality: "Philippine, Filipino",
  },
  {
    id: "612",
    alpha_2_code: "PN",
    alpha_3_code: "PCN",
    textDropDownEn: "Pitcairn",
    nationality: "Pitcairn Island",
  },
  {
    id: "616",
    alpha_2_code: "PL",
    alpha_3_code: "POL",
    textDropDownEn: "Poland",
    nationality: "Polish",
  },
  {
    id: "620",
    alpha_2_code: "PT",
    alpha_3_code: "PRT",
    textDropDownEn: "Portugal",
    nationality: "Portuguese",
  },
  {
    id: "630",
    alpha_2_code: "PR",
    alpha_3_code: "PRI",
    textDropDownEn: "Puerto Rico",
    nationality: "Puerto Rican",
  },
  {
    id: "634",
    alpha_2_code: "QA",
    alpha_3_code: "QAT",
    textDropDownEn: "Qatar",
    nationality: "Qatari",
  },
  {
    id: "638",
    alpha_2_code: "RE",
    alpha_3_code: "REU",
    textDropDownEn: "R\u00e9union",
    nationality: "R\u00e9unionese, R\u00e9unionnais",
  },
  {
    id: "642",
    alpha_2_code: "RO",
    alpha_3_code: "ROU",
    textDropDownEn: "Romania",
    nationality: "Romanian",
  },
  {
    id: "643",
    alpha_2_code: "RU",
    alpha_3_code: "RUS",
    textDropDownEn: "Russian Federation",
    nationality: "Russian",
  },
  {
    id: "646",
    alpha_2_code: "RW",
    alpha_3_code: "RWA",
    textDropDownEn: "Rwanda",
    nationality: "Rwandan",
  },
  {
    id: "652",
    alpha_2_code: "BL",
    alpha_3_code: "BLM",
    textDropDownEn: "Saint Barth\u00e9lemy",
    nationality: "Barth\u00e9lemois",
  },
  {
    id: "654",
    alpha_2_code: "SH",
    alpha_3_code: "SHN",
    textDropDownEn: "Saint Helena, Ascension and Tristan da Cunha",
    nationality: "Saint Helenian",
  },
  {
    id: "659",
    alpha_2_code: "KN",
    alpha_3_code: "KNA",
    textDropDownEn: "Saint Kitts and Nevis",
    nationality: "Kittitian or Nevisian",
  },
  {
    id: "662",
    alpha_2_code: "LC",
    alpha_3_code: "LCA",
    textDropDownEn: "Saint Lucia",
    nationality: "Saint Lucian",
  },
  {
    id: "663",
    alpha_2_code: "MF",
    alpha_3_code: "MAF",
    textDropDownEn: "Saint Martin (French part)",
    nationality: "Saint-Martinoise",
  },
  {
    id: "666",
    alpha_2_code: "PM",
    alpha_3_code: "SPM",
    textDropDownEn: "Saint Pierre and Miquelon",
    nationality: "Saint-Pierrais or Miquelonnais",
  },
  {
    id: "670",
    alpha_2_code: "VC",
    alpha_3_code: "VCT",
    textDropDownEn: "Saint Vincent and the Grenadines",
    nationality: "Saint Vincentian, Vincentian",
  },
  {
    id: "882",
    alpha_2_code: "WS",
    alpha_3_code: "WSM",
    textDropDownEn: "Samoa",
    nationality: "Samoan",
  },
  {
    id: "674",
    alpha_2_code: "SM",
    alpha_3_code: "SMR",
    textDropDownEn: "San Marino",
    nationality: "Sammarinese",
  },
  {
    id: "678",
    alpha_2_code: "ST",
    alpha_3_code: "STP",
    textDropDownEn: "Sao Tome and Principe",
    nationality: "S\u00e3o Tom\u00e9an",
  },
  {
    id: "682",
    alpha_2_code: "SA",
    alpha_3_code: "SAU",
    textDropDownEn: "Saudi Arabia",
    nationality: "Saudi, Saudi Arabian",
  },
  {
    id: "686",
    alpha_2_code: "SN",
    alpha_3_code: "SEN",
    textDropDownEn: "Senegal",
    nationality: "Senegalese",
  },
  {
    id: "688",
    alpha_2_code: "RS",
    alpha_3_code: "SRB",
    textDropDownEn: "Serbia",
    nationality: "Serbian",
  },
  {
    id: "690",
    alpha_2_code: "SC",
    alpha_3_code: "SYC",
    textDropDownEn: "Seychelles",
    nationality: "Seychellois",
  },
  {
    id: "694",
    alpha_2_code: "SL",
    alpha_3_code: "SLE",
    textDropDownEn: "Sierra Leone",
    nationality: "Sierra Leonean",
  },
  {
    id: "702",
    alpha_2_code: "SG",
    alpha_3_code: "SGP",
    textDropDownEn: "Singapore",
    nationality: "Singaporean",
  },
  {
    id: "534",
    alpha_2_code: "SX",
    alpha_3_code: "SXM",
    textDropDownEn: "Sint Maarten (Dutch part)",
    nationality: "Sint Maarten",
  },
  {
    id: "703",
    alpha_2_code: "SK",
    alpha_3_code: "SVK",
    textDropDownEn: "Slovakia",
    nationality: "Slovak",
  },
  {
    id: "705",
    alpha_2_code: "SI",
    alpha_3_code: "SVN",
    textDropDownEn: "Slovenia",
    nationality: "Slovenian, Slovene",
  },
  {
    id: "90",
    alpha_2_code: "SB",
    alpha_3_code: "SLB",
    textDropDownEn: "Solomon Islands",
    nationality: "Solomon Island",
  },
  {
    id: "706",
    alpha_2_code: "SO",
    alpha_3_code: "SOM",
    textDropDownEn: "Somalia",
    nationality: "Somali, Somalian",
  },
  {
    id: "710",
    alpha_2_code: "ZA",
    alpha_3_code: "ZAF",
    textDropDownEn: "South Africa",
    nationality: "South African",
  },
  {
    id: "239",
    alpha_2_code: "GS",
    alpha_3_code: "SGS",
    textDropDownEn: "South Georgia and the South Sandwich Islands",
    nationality: "South Georgia or South Sandwich Islands",
  },
  {
    id: "728",
    alpha_2_code: "SS",
    alpha_3_code: "SSD",
    textDropDownEn: "South Sudan",
    nationality: "South Sudanese",
  },
  {
    id: "724",
    alpha_2_code: "ES",
    alpha_3_code: "ESP",
    textDropDownEn: "Spain",
    nationality: "Spanish",
  },
  {
    id: "144",
    alpha_2_code: "LK",
    alpha_3_code: "LKA",
    textDropDownEn: "Sri Lanka",
    nationality: "Sri Lankan",
  },
  {
    id: "729",
    alpha_2_code: "SD",
    alpha_3_code: "SDN",
    textDropDownEn: "Sudan",
    nationality: "Sudanese",
  },
  {
    id: "740",
    alpha_2_code: "SR",
    alpha_3_code: "SUR",
    textDropDownEn: "Suriname",
    nationality: "Surinamese",
  },
  {
    id: "744",
    alpha_2_code: "SJ",
    alpha_3_code: "SJM",
    textDropDownEn: "Svalbard and Jan Mayen",
    nationality: "Svalbard",
  },
  {
    id: "748",
    alpha_2_code: "SZ",
    alpha_3_code: "SWZ",
    textDropDownEn: "Swaziland",
    nationality: "Swazi",
  },
  {
    id: "752",
    alpha_2_code: "SE",
    alpha_3_code: "SWE",
    textDropDownEn: "Sweden",
    nationality: "Swedish",
  },
  {
    id: "756",
    alpha_2_code: "CH",
    alpha_3_code: "CHE",
    textDropDownEn: "Switzerland",
    nationality: "Swiss",
  },
  {
    id: "760",
    alpha_2_code: "SY",
    alpha_3_code: "SYR",
    textDropDownEn: "Syrian Arab Republic",
    nationality: "Syrian",
  },
  {
    id: "158",
    alpha_2_code: "TW",
    alpha_3_code: "TWN",
    textDropDownEn: "Taiwan, Province of China",
    nationality: "Chinese, Taiwanese",
  },
  {
    id: "762",
    alpha_2_code: "TJ",
    alpha_3_code: "TJK",
    textDropDownEn: "Tajikistan",
    nationality: "Tajikistani",
  },
  {
    id: "834",
    alpha_2_code: "TZ",
    alpha_3_code: "TZA",
    textDropDownEn: "Tanzania, United Republic of",
    nationality: "Tanzanian",
  },
  {
    id: "764",
    alpha_2_code: "TH",
    alpha_3_code: "THA",
    textDropDownEn: "Thailand",
    nationality: "Thai",
  },
  {
    id: "626",
    alpha_2_code: "TL",
    alpha_3_code: "TLS",
    textDropDownEn: "Timor-Leste",
    nationality: "Timorese",
  },
  {
    id: "768",
    alpha_2_code: "TG",
    alpha_3_code: "TGO",
    textDropDownEn: "Togo",
    nationality: "Togolese",
  },
  {
    id: "772",
    alpha_2_code: "TK",
    alpha_3_code: "TKL",
    textDropDownEn: "Tokelau",
    nationality: "Tokelauan",
  },
  {
    id: "776",
    alpha_2_code: "TO",
    alpha_3_code: "TON",
    textDropDownEn: "Tonga",
    nationality: "Tongan",
  },
  {
    id: "780",
    alpha_2_code: "TT",
    alpha_3_code: "TTO",
    textDropDownEn: "Trinidad and Tobago",
    nationality: "Trinidadian or Tobagonian",
  },
  {
    id: "788",
    alpha_2_code: "TN",
    alpha_3_code: "TUN",
    textDropDownEn: "Tunisia",
    nationality: "Tunisian",
  },
  {
    id: "792",
    alpha_2_code: "TR",
    alpha_3_code: "TUR",
    textDropDownEn: "Turkey",
    nationality: "Turkish",
  },
  {
    id: "795",
    alpha_2_code: "TM",
    alpha_3_code: "TKM",
    textDropDownEn: "Turkmenistan",
    nationality: "Turkmen",
  },
  {
    id: "796",
    alpha_2_code: "TC",
    alpha_3_code: "TCA",
    textDropDownEn: "Turks and Caicos Islands",
    nationality: "Turks and Caicos Island",
  },
  {
    id: "798",
    alpha_2_code: "TV",
    alpha_3_code: "TUV",
    textDropDownEn: "Tuvalu",
    nationality: "Tuvaluan",
  },
  {
    id: "800",
    alpha_2_code: "UG",
    alpha_3_code: "UGA",
    textDropDownEn: "Uganda",
    nationality: "Ugandan",
  },
  {
    id: "804",
    alpha_2_code: "UA",
    alpha_3_code: "UKR",
    textDropDownEn: "Ukraine",
    nationality: "Ukrainian",
  },
  {
    id: "784",
    alpha_2_code: "AE",
    alpha_3_code: "ARE",
    textDropDownEn: "United Arab Emirates",
    nationality: "Emirati, Emirian, Emiri",
  },
  {
    id: "826",
    alpha_2_code: "GB",
    alpha_3_code: "GBR",
    textDropDownEn: "United Kingdom of Great Britain and Northern Ireland",
    nationality: "British, UK",
  },
  {
    id: "581",
    alpha_2_code: "UM",
    alpha_3_code: "UMI",
    textDropDownEn: "United States Minor Outlying Islands",
    nationality: "American",
  },
  {
    id: "840",
    alpha_2_code: "US",
    alpha_3_code: "USA",
    textDropDownEn: "United States of America",
    nationality: "American",
  },
  {
    id: "858",
    alpha_2_code: "UY",
    alpha_3_code: "URY",
    textDropDownEn: "Uruguay",
    nationality: "Uruguayan",
  },
  {
    id: "860",
    alpha_2_code: "UZ",
    alpha_3_code: "UZB",
    textDropDownEn: "Uzbekistan",
    nationality: "Uzbekistani, Uzbek",
  },
  {
    id: "548",
    alpha_2_code: "VU",
    alpha_3_code: "VUT",
    textDropDownEn: "Vanuatu",
    nationality: "Ni-Vanuatu, Vanuatuan",
  },
  {
    id: "862",
    alpha_2_code: "VE",
    alpha_3_code: "VEN",
    textDropDownEn: "Venezuela (Bolivarian Republic of)",
    nationality: "Venezuelan",
  },
  {
    id: "704",
    alpha_2_code: "VN",
    alpha_3_code: "VNM",
    textDropDownEn: "Vietnam",
    nationality: "Vietnamese",
  },
  {
    id: "92",
    alpha_2_code: "VG",
    alpha_3_code: "VGB",
    textDropDownEn: "Virgin Islands (British)",
    nationality: "British Virgin Island",
  },
  {
    id: "850",
    alpha_2_code: "VI",
    alpha_3_code: "VIR",
    textDropDownEn: "Virgin Islands (U.S.)",
    nationality: "U.S. Virgin Island",
  },
  {
    id: "876",
    alpha_2_code: "WF",
    alpha_3_code: "WLF",
    textDropDownEn: "Wallis and Futuna",
    nationality: "Wallis and Futuna, Wallisian or Futunan",
  },
  {
    id: "732",
    alpha_2_code: "EH",
    alpha_3_code: "ESH",
    textDropDownEn: "Western Sahara",
    nationality: "Sahrawi, Sahrawian, Sahraouian",
  },
  {
    id: "887",
    alpha_2_code: "YE",
    alpha_3_code: "YEM",
    textDropDownEn: "Yemen",
    nationality: "Yemeni",
  },
  {
    id: "894",
    alpha_2_code: "ZM",
    alpha_3_code: "ZMB",
    textDropDownEn: "Zambia",
    nationality: "Zambian",
  },
  {
    id: "716",
    alpha_2_code: "ZW",
    alpha_3_code: "ZWE",
    textDropDownEn: "Zimbabwe",
    nationality: "Zimbabwean",
  },
];
